import api from "@/services/api";

const { get, post } = api.getPrefixedMethods("mentions");

export default {
  listMentions(page = 1, query = "", archived = false) {
    return get("", { params: { page, ...(query ? { q: query } : {}), ...(archived ? { archived: "true" } : {}) } });
  },
  archive(id) {
    return post(`${id}/archive`);
  },
  unarchive(id) {
    return post(`${id}/unarchive`);
  },
  createMention({ recipientIds, groupIds, everyone = false, message, orderKey, intakeDocumentKey, intakeOrderId }) {
    return post("", {
      recipientIds,
      groupIds,
      everyone,
      message,
      orderKey,
      intakeDocumentKey,
      intakeOrderId,
    });
  },
  markRead(id) {
    return post(`${id}/read`);
  },
  markUnread(id) {
    return post(`${id}/unread`);
  },
  markAllRead() {
    return post("read-all");
  },
  getUnreadCount() {
    return get("unread-count");
  },
};
